module.exports = __webpack_public_path__ + "img/management-board.1e106ca2.svg";